module.exports = __webpack_public_path__ + "static/media/covi_mar_wal_mar.57705903.png";